import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import './Common.css';

function Table({
  columns,
  data,
  loading,
  onEdit,
  onDelete,
  actions = true,
  customActions,
  rowClassName,
  selectable = false,
  selectedIds = [],
  onToggleRow,
  onToggleAll,
}) {
  const showActionsColumn = actions || !!customActions;
  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (!data || data.length === 0) {
    return <div className="no-data">Aucune donnée disponible</div>;
  }

  const selectedSet = new Set(selectedIds);
  const allSelected = selectable && data.length > 0 && data.every((row) => selectedSet.has(row.id));

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            {selectable && (
              <th style={{ width: '36px', textAlign: 'center' }}>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => onToggleAll && onToggleAll(e.target.checked)}
                  title="Tout sélectionner"
                />
              </th>
            )}
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
            {showActionsColumn && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id} className={rowClassName ? rowClassName(row) : ''}>
              {selectable && (
                <td style={{ textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={selectedSet.has(row.id)}
                    onChange={() => onToggleRow && onToggleRow(row.id)}
                  />
                </td>
              )}
              {columns.map((column) => (
                <td key={column.key}>
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </td>
              ))}
              {showActionsColumn && (
                <td>
                  <div className="action-buttons">
                    {actions && onEdit && (
                      <button
                        onClick={() => onEdit(row)}
                        className="icon-btn icon-btn--accent"
                        title="Modifier"
                        aria-label="Modifier"
                      >
                        <Pencil size={16} />
                      </button>
                    )}
                    {customActions && customActions(row)}
                    {actions && onDelete && (
                      <button
                        onClick={() => onDelete(row.id)}
                        className="icon-btn icon-btn--danger"
                        title="Supprimer"
                        aria-label="Supprimer"
                      >
                        <Trash2 size={16} />
                      </button>
                    )}
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
